import * as React from 'react';
import { ViewportProvider } from '@shared-ui/viewport-context';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Collects all exported controllers from the client
 * application as an array.
 */
var initializeControllers = function (controllers) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (!controllers) {
            throw new Error('Could not find Controller factories in the configuration.');
        }
        if (controllers instanceof Function) {
            controllers = controllers();
        }
        if (!Array.isArray(controllers)) {
            throw new TypeError('Controllers should be exported as an array of Controller class definitions.');
        }
        return [2 /*return*/, controllers.map(function (controller) { return new controller(); })];
    });
}); };

function ControllersPlugin(_a) {
    var factories = _a.factories;
    return {
        name: 'controllers',
        onBrowserHydrateRenderContext: function (pluginOptions, next) {
            return __awaiter(this, void 0, void 0, function () {
                var setAppData, hydratedState, stores, controllers;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            setAppData = pluginOptions.setAppData, hydratedState = pluginOptions.hydratedState;
                            stores = hydratedState.stores;
                            return [4 /*yield*/, initializeControllers(factories.controllers)];
                        case 1:
                            controllers = _a.sent();
                            setAppData({ stores: stores, controllers: controllers });
                            return [2 /*return*/, next(pluginOptions)];
                    }
                });
            });
        },
        onBrowserWrapRootElement: function (pluginOptions, next) {
            var getAppData = pluginOptions.getAppData, setRootElement = pluginOptions.setRootElement;
            var context = getAppData().context;
            var deviceInformation = context.deviceInformation;
            setRootElement(function (RootElement) { return function (props) { return (React.createElement(ViewportProvider, { deviceInformation: deviceInformation },
                React.createElement(RootElement, null, props.children))); }; });
            return next(pluginOptions);
        },
    };
}

export { ControllersPlugin as default };
//# sourceMappingURL=browser.js.map
